import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import dashboardService from "../../services/dashboard-week-service";
import sectionService from "../../services/section-service";
import { registerLocale } from "react-datepicker";
import { Button, DatePicker, Divider, Spin } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import userService from "../../services/user-service";
import config from "../../config/config";
import Select from "react-select";
import moment from "moment/moment";

import dayjs from "dayjs";
import "dayjs/locale/es";
import isoWeek from "dayjs/plugin/isoWeek";
import LineChart from "../DashBoard/LineChart";
dayjs.extend(isoWeek);

dayjs.locale("es");

// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashboardQuantityWeek = () => {

  const start_date = dayjs().subtract(4, "week").startOf("day");
  const end_date = dayjs().endOf("day");
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);


  const [lineQuantityData, setLineQuantityData] = useState([]);
  const [lineHectaresData, setLineHectaresData] = useState([]);

  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);
  const chartFourRef = useRef(null);
  const chartFiveRef = useRef(null);


  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)

  ///Aplicaciones por dia
  const [farmId, setFarmId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [userId, setUserId] = useState("0");


  ////CONSTANTES DE COORRELACION////////////////////////

  const [totalFirst, setTotalFirst] = useState(0)



  const [serieFirstApplicationDay, setSerieFirstApplicationDay] = useState([])
  const [listFirstApplicationDay, setListFirstApplicationDay] = useState([])




  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);




  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////


  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };

  const formatMonth = (yearMonth) => {
    const [year, month] = yearMonth.split("-").map(Number);
    const date = new Date(year, month - 1);
    return new Intl.DateTimeFormat("es-ES", { month: "short" }).format(date);
  };

  const formatMonthYearIntl = (yearMonth) => {
    const [year, month] = yearMonth.split("-").map(Number);
    const date = new Date(year, month - 1);
    return new Intl.DateTimeFormat("es-ES", { month: "short", year: "numeric" }).format(date);
  };

  const changeStateShowValues = (e) => {
    setShowLineValues(!e.target.checked)
  }

  const changeExpand = (e) => {
    setExpandCharts(e.target.checked)
  }

  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };


  /// PRIMERAS APLICACIONES POR DIA
  const firstApplicationsByWeek = async () => {
    let counter = 0;
    let start = dayjs(startDate).startOf("day").format("YYYY-MM-DD");
    let end = dayjs(endDate).endOf("day").format("YYYY-MM-DD");

    setLineQuantityData([])
    let list = [];
    const lotId="0"
    const result = await dashboardService.applicationsByWeek(start, end, farmId, lotId, sectionId, selectedLotes,userId);
    if (result) {
      result.map((item) => {
        //const day =formatDate(item._id) ;
        const day = item.weekStartDate
        const total = item.totalApplications;
        counter += total;
        list.push({ value: [day, total] })
      });
    }
    setLineQuantityData(list)
    setTotalFirst(counter)
  };





  /// HECTAREAS POR DIA
  const hectaresByWeek = async () => {
    let counter = 0;
    let start = dayjs(startDate).startOf("day").format("YYYY-MM-DD");
    let end = dayjs(endDate).endOf("day").format("YYYY-MM-DD");

    setLineHectaresData([])
    let list = [];
    const lotId="0"
    const result = await dashboardService.hectaresByWeek(start, end, farmId, lotId, sectionId, selectedLotes,userId);
    if (result) {
      result.map((item) => {
        //const day =formatDate(item._id) ;
        const day = item.weekStartDate
        const total = item.totalHectares.toFixed(2);
        list.push({ value: [day, total] })
      });
    }
    setLineHectaresData(list)
    setTotalFirst(counter)
  };









  const loadDashBoard = () => {
    firstApplicationsByWeek()
    hectaresByWeek()
  };

  const {
    register,
    setValue,
    formState: { errors },
  } = useForm();



  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };

  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };





  useEffect(() => {
    getLisFarm();
    loadDashBoard()
    getListFilterUsers()
  }, []);


  const getListFilterUsers = async () => {
    const userId = "0"
    setValue("userId", "0")
    setUserId("0")
    try {
      let start = dayjs(startDate).startOf("day").format("YYYY-MM-DD");
      let end = dayjs(endDate).endOf("day").format("YYYY-MM-DD");

      const response = await userService.listInAccumulation(start, end, farmId, sectionId)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
  }
  useEffect(() => {
    getListFilterUsers();
  }, [startDate, endDate, farmId, sectionId]);



  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >


      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Dashboard cantidades semanal</Divider>
      </div>
      <div className="row">
        <div className="col-12">
          <form className="form-react">
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>







              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  className="form-control text-secondary"
                  picker="week"
                  value={startDate}
                  onChange={(date) => {
                    if (date) {
                      const startOfWeek = date.startOf("isoWeek");
                      console.log("fin seleccionada:", startOfWeek.format("YYYY-MM-DD"));
                      setStartDate(startOfWeek);

                    } else {
                      setStartDate(null);
                    }
                  }}
                />
              </div>

              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  className="form-control text-secondary"
                  picker="week"
                  value={endDate}
                  onChange={(date) => {
                    if (date) {
                      const endOfWeek = date.endOf("isoWeek");
                      console.log("fin seleccionada:", endOfWeek.format("YYYY-MM-DD"));
                      setEndDate(endOfWeek);
                    } else {
                      setEndDate(null);
                    }
                  }}
                />

              </div>

              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Cargar gráficos
                </button>
              </div>


              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>


              <div className=" col-12 col-sm-4 ">
                <label className="text-secondary fw-bold">Usuario</label>
                <select
                  className="form-control text-secondary"
                  {...register("userId")}
                  onChange={(e)=>{

                    const value = e.target.value
                    setUserId(value)

                  }}
                >
                  {listUsers.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className="mt-2 col-6 col-sm-2"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeExpand(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Ampliar grafica</label>
                </div>
              </div>

            </div>



          </form>
        </div>








        <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-6 mt-2"}>
          <div style={cardStyle}>
            <LineChart
              decimals={1}
              data={lineQuantityData}
              chartRef={chartOneRef}
              title="Aplicaciones por semana"
              subTitle="Total de aplicaciones semanales en campo"
              seriesTitle="Aplicaciones"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "aplicaciones semana.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>




        <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-6 mt-2"}>
          <div style={cardStyle}>
            <LineChart
              decimals={1}
              data={lineHectaresData}
              chartRef={chartTwoRef}
              title="Hectáreas por semana"
              subTitle="Total de Hectáreas semanales en campo"
              seriesTitle="Aplicaciones"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartTwoRef, "hectareas semana.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>













      </div>
    </div>
  );
};

export default DashboardQuantityWeek;
